import { StyledSiderMenu } from 'styles/overrides';

export const SiderMenu = (props) => {
  return <StyledSiderMenu theme="dark" mode="inline" {...props} />;
};
